<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :request-query-string-params="{ not_usuario_id: usuariosSupervisoresIds }"
                    :search-fields="fields.usuario"
                    :validations="validations.usuario"
                    label="Usuário"
                    text-field="cidadaoNome"
                    uppercase
                    v-model="model.usuario"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                usuario: { required: true },
            }
        },
        usuariosSupervisoresIds() {

            return this.data.model.supervisores.map(s => s.usuario.id)
        },
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
        }
    },
    data: () => ({
        fields: {
            usuario: [
                { key: 'cadastroCidadao.nome', searchable: true },
            ],
        },
        model: {
            id: null,
            usuario: null,
        }
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.data.model.supervisores.push(this.prepareData())

                    this.$emit('save')
                })
        },
        prepareData() {

            return this.clone(this.model)
        }
    },
    mixins: [repository, object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>